const ConfirmSaleModal = ({ data, onConfirm, onCancel }) => {
  const { userDni, amount, discount, total, promotionLabel } = data;

  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center fixed top-0 left-0 right-0 z-[200] bg-gray-900/50 backdrop-blur-sm transition-opacity">
      <div className="relative w-4/5 max-w-md flex flex-col bg-white shadow-md my-0 mx-auto rounded-lg font-body text-gray-900 p-3">
        <h1 className="font-bold text-xl mb-4 text-center">¿Estás seguro?</h1>
        <div className="text-left mb-6">
          <p className="pb-1">
            <b>DNI:</b> {userDni}
          </p>
          <p className="pb-1">
            <b>Promoción:</b> {promotionLabel}
          </p>
          <p className="pb-1">
            <b>Importe sin descuento:</b> ${amount.toFixed(2)}
          </p>
          <p className="pb-1">
            <b>Descuento a aplicar:</b> ${discount.toFixed(2)}
          </p>
          <p className="pt-2 text-lg font-bold">
            Total a pagar: ${total.toFixed(2)}
          </p>
        </div>
        <div className="flex justify-center gap-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 rounded-full border border-gray-400 text-gray-700 hover:bg-gray-100"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 rounded-full bg-clvblue text-white hover:bg-clvHoverBlue"
          >
            Sí, confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmSaleModal;
